import Logo from '@/components/svg/Logo';
import MobileLogo from '@/components/svg/MobileLogo';
import { DesktopLogoWrapper, LogoContainer, MobileLogoWrapper, PageWrapper } from './Branding.styles';

export const MobileOnlyLogo = () => (
  <MobileLogoWrapper aria-hidden="true">
    <MobileLogo />
  </MobileLogoWrapper>
);

export const WithPageWrapper = (component: React.ReactElement, wrapped = false) => {
  if (wrapped) {
    return (
      <PageWrapper>
        <LogoContainer>
          <DesktopLogoWrapper aria-hidden="true">
            <Logo />
          </DesktopLogoWrapper>
        </LogoContainer>
        {component}
      </PageWrapper>
    );
  }
  return component;
};
